var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.5H4.5V14H13.5V2H4.5V3.5H3V1.25C3 1.05109 3.07902 0.860322 3.21967 0.71967C3.36032 0.579018 3.55109 0.5 3.75 0.5H14.25C14.4489 0.5 14.6397 0.579018 14.7803 0.71967C14.921 0.860322 15 1.05109 15 1.25V14.75C15 14.9489 14.921 15.1397 14.7803 15.2803C14.6397 15.421 14.4489 15.5 14.25 15.5H3.75C3.55109 15.5 3.36032 15.421 3.21967 15.2803C3.07902 15.1397 3 14.9489 3 14.75V12.5ZM4.5 7.25H9.75V8.75H4.5V11L0.75 8L4.5 5V7.25Z",
    fill: "#002841",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignout);
export default __webpack_public_path__ + "static/media/signout.faf9b86338ba06bf2ebfc5a0c5d39c18.svg";
export { ForwardRef as ReactComponent };